module.exports = __webpack_public_path__ + "img/数据安全.b2ff12f1.svg";